'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchSellersDetailsIfNeeded = exports.isSellerDetailLoading = exports.getLoadTimeForSellerDetail = exports.getSellerDetail = exports.LOAD_SELLER_DETAILS_SUCCESS = exports.LOAD_SELLER_DETAILS_REQUEST = exports.LOAD_SELLER_DETAILS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('../modules/user');

var _config = require('../modules/config');

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_SELLER_DETAILS_FAIL = exports.LOAD_SELLER_DETAILS_FAIL = 'la/domain/sellerDetail/LOAD_FAIL';
var LOAD_SELLER_DETAILS_REQUEST = exports.LOAD_SELLER_DETAILS_REQUEST = 'la/domain/sellerDetail/LOAD_REQUEST';
var LOAD_SELLER_DETAILS_SUCCESS = exports.LOAD_SELLER_DETAILS_SUCCESS = 'la/domain/sellerDetail/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_SELLER_DETAILS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.sellerIds)
            });
        case LOAD_SELLER_DETAILS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_SELLER_DETAILS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.sellerDetails) {
                action.payload.sellerDetails.forEach(function (x) {
                    existing[x.sellerId] = (0, _extends3.default)({}, x);
                    loaded[x.sellerId] = time;
                    loading = (0, _difference2.default)(loading, [x.sellerId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerDetail;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns the data
var getSellerDetail = exports.getSellerDetail = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

// takes in a (state, id) and returns the load time
var getLoadTimeForSellerDetail = exports.getLoadTimeForSellerDetail = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns the is loading
var isSellerDetailLoading = exports.isSellerDetailLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.indexOf(id) !== -1;
});

var shouldFetchSellerDetail = function shouldFetchSellerDetail(state, sellerId) {
    var data = getSellerDetail(state, sellerId);
    if (!(0, _isEmpty2.default)(data)) {
        var loaded = getLoadTimeForSellerDetail(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerDetailLoading(state, sellerId);
    return !loading;
};

var whichSellerDetailsNeeded = function whichSellerDetailsNeeded(state, sellerIds) {
    return sellerIds.filter(function (sellerId) {
        return shouldFetchSellerDetail(state, sellerId);
    });
};

/* ACTION CREATORS */
var loadSellerDetails = function loadSellerDetails(sellerIds) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: sellerIds,
                                type: LOAD_SELLER_DETAILS_REQUEST
                            });
                            _context.next = 7;
                            return _api.SellerDetail.fetchSellerDetailsByIds({ authToken: authToken, deployment: deployment, sellerIds: sellerIds });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), sellerIds: sellerIds },
                                payload: response.data,
                                type: LOAD_SELLER_DETAILS_SUCCESS
                            });
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { sellerIds: sellerIds },
                                payload: _context.t0,
                                type: LOAD_SELLER_DETAILS_FAIL
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 11]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var fetchSellersDetailsIfNeeded = exports.fetchSellersDetailsIfNeeded = function fetchSellersDetailsIfNeeded(sellerIds) {
    return function (dispatch, getState) {
        var needed = whichSellerDetailsNeeded(getState(), sellerIds);
        if (needed.length) {
            return dispatch(loadSellerDetails(needed));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/sellerDetail.js
// module id = vi1m
// module chunks = 46